import {
  PrimaryControlsStripBackContext,
  type PrimaryControlsStripBackRegistryEntry,
} from "@-/dev.improve.haniverse.contexts.primary-controls-strip.back";
import { useCallback, useContext, useSyncExternalStore } from "react";
import { Platform } from "@-/com.npmjs.react-native";

const isWeb = Platform.OS === "web";

/**
 * The top-left slot's winning registry entry, kept current. Always `null` on web: web mounts no
 * `PrimaryControlsStripBackProvider`, so the context resolves to the `defaultError` proxy and even reading
 * `getCurrent()` would throw. The hooks still run unconditionally, keeping hook order stable.
 */
export function usePrimaryControlsStripBackRegistryCurrent(): PrimaryControlsStripBackRegistryEntry | null {
  const registry = useContext(PrimaryControlsStripBackContext);
  const getSnapshot = useCallback(() => (isWeb ? null : registry.getCurrent()), [registry]);
  const subscribe = useCallback(
    (onStoreChange: () => void) => (isWeb ? () => {} : registry.subscribe(onStoreChange)),
    [registry],
  );
  // Host visibility and portal content must use the same snapshot, including on the first
  // render. Passive-effect subscriptions could leave one a frame behind the other.
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
